var map = {
	"./template.betgalaxy": 2031,
	"./template.betgalaxy.tsx": 2031,
	"./template.betroyale": 1108,
	"./template.betroyale.tsx": 1108,
	"./template.default": 657,
	"./template.default.tsx": 657,
	"./template.fiestabet": 1109,
	"./template.fiestabet.tsx": 1109,
	"./template.puntgenie": 1110,
	"./template.puntgenie.tsx": 1110,
	"./template.questbet": 1111,
	"./template.questbet.tsx": 1111,
	"./template.sterlingparker": 1112,
	"./template.sterlingparker.tsx": 1112,
	"./template.ts": 212,
	"./template.volcanobet": 1113,
	"./template.volcanobet.tsx": 1113,
	"./template.wellbet": 1114,
	"./template.wellbet.tsx": 1114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2426;